import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NodeInf} from '../../../interfaces/network/node-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';

export interface NodeDialogInf {
  items: [NodeInf];
  selectedItem: NodeInf;
  isEditMode?: boolean;
  routingServerGroups: any;
  nodeUsers: any;
  nodeCredentials: any;
  isSupportsTeams: boolean;
  isLegacyNode: boolean;
}

@Component({
  selector: 'nodes-dialog',
  templateUrl: './nodes-dialog.component.html',
  styleUrls: ['./nodes-dialog.component.scss']
})
export class NodesDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isCollapsed = true;
  transportTypeOptions = [{text: 'HTTP', value: 'HTTP'}, {text: 'HTTPS', value: 'HTTPS'}];
  teamsRoleOptions = [
    {text: 'Proxy', value: 'PROXY'},
    {text: 'Remote', value: 'REMOTE'},
    {text: 'Not Teams', value: 'NOT_TEAMS'}
  ];
  isAuthorized: boolean;

  constructor(public dialogRef: MatDialogRef<NodeDialogInf>,
              @Inject(MAT_DIALOG_DATA) public data: NodeDialogInf,
              private userPrivilege: UserPrivilegeService) {
  }

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();
    if (!this.data.isEditMode){
      this.data.selectedItem.teamsRole = 'NOT_TEAMS';
      this.data.selectedItem.transportType = 'HTTPS';
    }
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    if (!this.data.isEditMode) {
      this.updateAddressProperty(this.data.selectedItem);
    }
    this.onApply.emit(this.data);
  }

  generateTopologyGroupsInfo(topologyGroups: any): any {
    return topologyGroups.map((group) => group.name);
  }

  isLegacyGroup(): boolean {
    const serverGroup = this.data.routingServerGroups.find((group) => {
      return group.id === this.data.selectedItem.routingServerGroupId;
    });
    return !!serverGroup ? serverGroup.legacy : false;
  }

  isTopologyGroups(): boolean {
    return this.data.selectedItem.topologyGroups && this.data.selectedItem.topologyGroups.length > 0;
  }

  private updateAddressProperty(node): void {
    if (node.isIpAddressProvidedForGUI === true) {
      node.ipAddr = node.addressForGUI;
      node.hostname = null;
    } else {
      node.hostname = node.addressForGUI;
      node.ipAddr = null;
    }
  }
}
